<template>
    <a-card>
        
        <h3 style="text-align: center;margin:20px 0 40px">研究人员信息</h3>
        <a-descriptions v-for="(item,key) in form" style="margin-bottom:10px" :key="key" size="middle" :column="{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }" bordered={true}>
            <a-descriptions-item label="研究人员姓名" name="name">{{item.name}}</a-descriptions-item>
            <a-descriptions-item label="性别" name="sex">
                <span v-if='item.sex==0'>男</span>
                <span v-if='item.sex==1'>女</span>
            </a-descriptions-item>
            <a-descriptions-item label="出生日期" name="birth">{{item.birth}}</a-descriptions-item>
            <a-descriptions-item label="学位（最高学历学位）" name="academicDegree">
				<dict-render :dict-obj="dictObjs['education_background']" :text="item.academicDegree" v-if="item.academicDegree"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="职务" name="duties">{{item.duties}}</a-descriptions-item>
            <a-descriptions-item label="专业" name="speciality">{{item.speciality}}</a-descriptions-item>
            <a-descriptions-item label="承担任务" name="undertakeTasks">{{item.undertakeTasks}}</a-descriptions-item>
            <a-descriptions-item label="单位" name="workUnit">{{item.workUnit}}</a-descriptions-item>
            <a-descriptions-item label="手机号" name="phone">{{item.phone}}</a-descriptions-item>
        </a-descriptions>
    </a-card>
</template>

<script>

    import { projectResearchers } from "@/api/TechnologieprojekteApply";
    import {
        dictMixin,
        formMixin
    } from "@/mixins";
    import DictRender from "@/components/other/DictRender";
    export default {
        name: "研究人员信息",
        mixins: [
        dictMixin,formMixin],
        components: {
            DictRender
        },
        data() {
            return {
                options: null,
                form:{
                },
                dictNames: "leaderType,education_background",
            }
        },

        mounted() {
            this.getData()
        },
        methods: {
            getData(){
                this.getAction({
                    url: projectResearchers.selectList,
                    params: { 
                        projectId: this.$route.query.projectId
                     }
                }).then((res) => {
                    this.form = res
                });
            }
        }

    }
</script>
